const hoek = require('@hapi/hoek');

const VRBEX = 'VRBEX';
const getPostBookingExperienceHeader = (request) =>
    hoek
        .reach(request, 'headers.x-vrbo-postbooking-experience', {default: ''})
        .toUpperCase();

const getConfirmationToTIDHeader = (request) =>
    hoek
        .reach(request, 'headers.x-vrbo-confirmation-to-tid', {default: ''})
        .toUpperCase();

const isVrbexPostBookingExperience = (request) =>
    getPostBookingExperienceHeader(request) === VRBEX;

const isConfirmationToTIDExperience = (request) =>
    getConfirmationToTIDHeader(request) === 'TRUE';

const isVrbexNativePostBookingExperience = (request) => {
    const queryParams = hoek.reach(request, 'query', {default: {}});

    return queryParams.vrbex === 'true' && queryParams.native === 'true';
};

module.exports = {
    getPostBookingExperienceHeader,
    isVrbexPostBookingExperience,
    isVrbexNativePostBookingExperience,
    isConfirmationToTIDExperience,
    VRBEX,
};
